import { render, staticRenderFns } from "./ImportView.vue?vue&type=template&id=be61df22&"
import script from "./ImportView.vue?vue&type=script&lang=ts&"
export * from "./ImportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports